import utils from '../utils/utils'
import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class Nav {
  constructor() {
    let scrollPos;
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.header = document.querySelector('header');
      cache.top_nav = cache.header.querySelector('.top');
      cache.top_navOpen = cache.top_nav.querySelector('.txt_open');
      cache.top_navClose = cache.top_nav.querySelector('.txt_close');
      cache.nav = document.querySelector('.menu_wrap');
      cache.navmobileBtn = document.querySelector('.nav_mobile');
      cache.searchBtn = document.querySelector('.search .open');
      cache.searchBtnClose = document.querySelector('.search .close');
      cache.searchBox = document.querySelector('.search_box');

      cache.widget = document.querySelector('.widget_links');
      cache.widgetOpen = document.querySelector('.widget_links .info .open');
      cache.widgetClose = document.querySelector('.widget_links .info .close');
      cache.widgetInner = document.querySelector('.widget_links .info .info_inner');
    };

    let registerEvents = () => {
      cache.navmobileBtn.addEventListener("click", openNav);

      cache.searchBtn.addEventListener("click", openSearch);
      cache.searchBtnClose.addEventListener("click", closeSearch);

      cache.widgetOpen.addEventListener("click", openWidget);
      cache.widgetClose.addEventListener("click", closeWidget);

      getHours(cache.top_nav.dataset.key);
    };

    let openNav = () => {
      cache.navmobileBtn.removeEventListener("click", openNav);
      cache.nav.style.display="block";
      cache.header.classList.add('open');
      document.querySelector('body').classList.add('overflow');
      document.querySelector('html').classList.add('overflow');
      anime({
        targets: cache.nav,
        opacity: [0,1],
        translateY: [-150,0],
        duration: 300,
        easing: 'easeOutQuad',
        complete: function() {
          cache.navmobileBtn.addEventListener("click", closeNav);
        }
      });
    }

    let closeNav = () => {
      cache.navmobileBtn.removeEventListener("click", closeNav);
      document.querySelector('body').classList.remove('overflow');
      document.querySelector('html').classList.remove('overflow');
      cache.header.classList.remove('open');
      anime({
        targets: cache.nav,
        opacity: [1,0],
        translateY: [0,-150],
        duration: 300,
        easing: 'easeOutQuad',
        complete: function() {
          cache.navmobileBtn.addEventListener("click", openNav);
          cache.nav.style.display="none";
        }
      });
    }

    let openWidget = () => {
      cache.widgetInner.style.display = "flex";
      anime({
        targets: cache.widgetInner,
        opacity: [0,1],
        translateX: [50,0],
        duration: 300,
        easing: 'easeOutQuad',
      });

      window.addEventListener('scroll', scrollDetect);
      scrollPos = window.pageYOffset;
    }
    let closeWidget = () => {
      window.removeEventListener('scroll', scrollDetect);
      anime({
        targets: cache.widgetInner,
        opacity: [1,0],
        translateX: [0,50],
        duration: 300,
        easing: 'easeOutQuad',
        complete: function() {
          cache.widgetInner.style.display = "none";
        }
      });
    }

    let scrollDetect = function() {
      if((window.pageYOffset > scrollPos+100) || (window.pageYOffset < scrollPos-100)) {
        closeWidget();
      }
    }

    let getHours = (id) => {

      const service = new google.maps.places.PlacesService(document.createElement("div"));
      let request = {
        placeId: id,
        fields: ["opening_hours",'utc_offset_minutes'],
      };

      service.getDetails(request, (place, status) => {
        if ( status === google.maps.places.PlacesServiceStatus.OK && place && place.opening_hours ) {
          const d = new Date();
          let day = d.getDay()-1;

          const dzone = d.toLocaleString('fr-FR', { timeZone: "Europe/Zurich" });
          const tzone = dzone.split(" ")[1];
          const hzone = tzone.split(":")[0];
          const mzone = tzone.split(":")[1];
          const time = parseInt((hzone+mzone));


          if(place.opening_hours.isOpen()) {
            cache.top_navOpen.style.display = 'block';
            cache.top_navClose.style.display = 'none';
            if(day < 0) {
              day = 6;
            }
            let hours = place.opening_hours.periods[day];
            cache.top_navOpen.querySelector('.open').textContent = formatTime(hours['open']['time']);
            cache.top_navOpen.querySelector('.close').textContent = formatTime(hours['close']['time']);
          }
          else {
            let txt;
            cache.top_navOpen.style.display = 'none';
            cache.top_navClose.style.display = 'block';
            const openT = parseInt(place.opening_hours.periods[day]['open']['time']);
            const closeT = parseInt(place.opening_hours.periods[day]['close']['time']);
            if((place.opening_hours.periods[day]) && (time < openT)) {
              if(document.documentElement.lang == "en-US") {
                txt = "Today";
              } else {
                txt = "Aujourd'hui";
              }
            }
            else {
              day++;
              if(day > 6) {
                day = 0;
              }
              if (!place.opening_hours.periods[day]) {
                if(day+1 > 6) {
                  day = 0;
                } else {
                  day++;
                }

                if (!place.opening_hours.periods[day]) {
                  day++;
                  if(day > 6) {
                    day = 0;
                  }
                }

                txt = formatDay(day);
              }
              else {
                if(document.documentElement.lang == "en-US") {
                  txt = "Tomorrow";
                } else {
                  txt = "Demain";
                }
              }
            }

            let hours = place.opening_hours.periods[day];
            cache.top_navClose.querySelector('.hour').textContent = formatTime(hours['open']['time']);
            cache.top_navClose.querySelector('.day').textContent = txt;
          }
        }

      });

    }


    let openSearch = function() {
      utils.disableScroll();
      cache.searchBox.style.display = "block";
      cache.header.classList.add('search_open');
      anime({
        targets: cache.searchBox,
        opacity: [0,1],
        scale: [0.8, 1],
        duration: 500,
        easing: 'easeOutQuad',
        complete: function() {
          cache.nav.style.display="none";
        }
      });
      anime({
        targets: cache.widget,
        translateX: ['0%','100%'],
        duration: 400,
        easing: 'easeOutQuad',
      });
      anime({
        targets: cache.searchBtn,
        opacity: 0,
        duration: 0,
        easing: 'easeOutQuad',
        complete: function() {
          cache.searchBtn.style.display="none";
        }
      });
      cache.searchBtnClose.style.display="block";
      anime({
        targets: cache.searchBtnClose,
        opacity: 1,
        duration: 400,
        easing: 'easeOutQuad',
      });
    }

    let closeSearch = function() {
      utils.enableScroll();
      cache.header.classList.remove('search_open');
      cache.nav.style.display="block";
      anime({
        targets: cache.searchBox,
        opacity: [1,0],
        scale: [1, 0.8],
        duration: 500,
        easing: 'easeOutQuad',
        complete: function() {
          cache.searchBox.style.display = "block";
        }
      });
      anime({
        targets: cache.widget,
        translateX: ['100%','0%'],
        duration: 400,
        easing: 'easeOutQuad',
      });
      anime({
        targets: cache.searchBtnClose,
        opacity: 0,
        duration: 300,
        easing: 'easeOutQuad',
        complete: function() {
          cache.searchBtnClose.style.display="none";
        }
      });
      cache.searchBtn.style.display="flex";
      anime({
        targets: cache.searchBtn,
        opacity: 1,
        duration: 400,
        easing: 'easeOutQuad',
      });
    }



    function formatTime(strTime) {
      let h = strTime.slice(0, 2);
      let m = strTime.slice(-2);
      return h+'h'+m;
    }

    function formatDay(day) {
      let dayName;

      if(document.documentElement.lang == "en-US") {
        if(day ==0) {
          dayName = "Monday";
        }
        if(day == 1) {
          dayName = "Tuesday";
        }
        if(day == 2) {
          dayName = "Wednesday";
        }
        if(day == 3) {
          dayName = "Thursday";
        }
        if(day == 4) {
          dayName = "Friday";
        }
        if(day == 5) {
          dayName = "Saturday";
        }
        if(day == 6) {
          dayName = "Sunday";
        }
      } else {
        if(day ==0) {
          dayName = "Lundi";
        }
        if(day == 1) {
          dayName = "Mardi";
        }
        if(day == 2) {
          dayName = "Mercredi";
        }
        if(day == 3) {
          dayName = "Jeudi";
        }
        if(day == 4) {
          dayName = "Vendredi";
        }
        if(day == 5) {
          dayName = "Samedi";
        }
        if(day == 6) {
          dayName = "Dimanche";
        }
      }
      return dayName;
    }

    initFunc();
  };
}
export { Nav }
